export function findProjectByUlid(projects, projectUlid) {
    return projects.find((project) => project.ulid === projectUlid)
}

export function environmentsForProject(projects, projectUlid) {
    return findProjectByUlid(projects, projectUlid)?.environments?.data ?? []
}

export function findProjectByEnvironmentUlid(projects, environmentUlid) {
    return projects.find((project) =>
        (project.environments?.data ?? []).some(
            (environment) => environment.ulid === environmentUlid
        )
    )
}
